<template>
  <div>
    <b-card-title>
      <b-row>
        <b-col
          md="3"
          class="pb-2"
        >
          <label for="zone">Zone</label>
          <b-form-input
            id="zone"
            :value="$route.params.zone"
            readonly
          />
        </b-col>
        <b-col
          md="3"
          class="pb-2"
        >
          <label for="service">Service</label>
          <b-form-input
            id="service"
            :value="$route.params.service"
            readonly
          />
        </b-col>
        <b-col class="d-flex justify-content-end align-items-center">
          <b-button
            :disabled="loadingConfig || loadingTabs "
            variant="success"
            @click="postForm"
          >
            Submit Trip Configuration
          </b-button>
        </b-col>
      </b-row>
    </b-card-title>
    <b-card>

      <b-form
        autocomplete="off"
        novalidate
      >
        <b-overlay
          variant="white"
          spinner-variant="primary"
          blur="0"
          opacity=".75"
          rounded="sm"
          :show="loadingTabs"
        >
          <template v-if="!loadingTabs">
            <b-tabs v-model="tabIndex">
              <fines-tab
                :fines="configObj.fines"
                :transaction-types-list="transactionTypes"
                @fines-set="configObj.fines = $event"
              />
              <rules-tab
                :rules="configObj.rules"
                @rules-set="configObj.rules = $event"
              />
              <cancellation-tab
                :cancellation-reasons="configObj.cancellation_reasons"
                @cancellations-set="configObj.cancellation_reasons= $event"
                @apply-cancellations="handleApplyCancellations(configObj)"
              />
              <screen-config
                :driver-offer="configObj.driver_offer"
                @save-screen-config="configObj.driver_offer = $event"
              />
              <display-phone-options
                :phone-options="configObj.display_phone_options"
                @display-phone-options-set="configObj.display_phone_options = $event"
              />
              <DelayDiscountTab
                :delay-discount="configObj.delay_discount"
                @delay-discount-set="configObj.delay_discount= $event"
                @apply-discount="handleSubmission(configObj)"
              />
              <DistanceBonusTab
                :bonus-array="configObj.distance_bonus"
                @distance-bonus-set="configObj.distance_bonus= $event"
                @applied="handleSubmission(configObj)"
              />
              <BogoConfigTab
                :bogo-array="configObj.bogo_config"
                @set="configObj.bogo_config= $event"
                @applied="handleSubmission(configObj)"
              />
            </b-tabs>
          </template>
        </b-overlay>
      </b-form>
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BCardTitle, BTabs, BRow, BCol, BFormInput, BForm, BOverlay, BButton,
} from 'bootstrap-vue'
import transactionTypesStore from '@/views/billing/transaction-types/transactionTypesStore'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import tripConfigStore from '../store'
import FinesTab from './tabs/FinesTab.vue'
import { successNotification, errorNotification } from '@/utils/toast-notifications'
import RulesTab from './tabs/RulesTab.vue'
import CancellationTab from './tabs/CancellationTab.vue'
import ScreenConfig from './tabs/ScreenConfig.vue'
import DisplayPhoneOptions from './tabs/DisplayPhoneOptions.vue'
import DelayDiscountTab from './tabs/DelayDiscountTab.vue'
import DistanceBonusTab from './tabs/DistanceBonusTab.vue'
import useTripConfigForm from '../hooks/useTripConfigForm'
import BogoConfigTab from './tabs/BogoConfigTab.vue'

export default {
  components: {
    DisplayPhoneOptions,
    BogoConfigTab,
    DistanceBonusTab,
    DelayDiscountTab,
    BButton,
    BCard,
    BCardTitle,
    BTabs,
    BRow,
    BCol,
    BFormInput,
    BForm,
    FinesTab,
    RulesTab,
    CancellationTab,
    ScreenConfig,
    BOverlay,
  },
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('tripConfig', tripConfigStore)
    useRegisterStoreModule('transactionTypes', transactionTypesStore)
    const handleApplyCancellations = async datae => {
      try {
        const result = await ctx.root.$store.dispatch('tripConfig/postconCellationResans', datae)
        console.log(result)
        successNotification('Saved...')
      } catch (error) {
        errorNotification('Fill out the required fields')
      }
    }
    const handleSubmission = async data => {
      try {
        await ctx.root.$store.dispatch('tripConfig/postForm', data)
        successNotification('Saved...')
      } catch (error) {
        errorNotification('Fill out the required fields')
      }
    }
    return {
      ...useTripConfigForm(props, ctx),
      handleApplyCancellations,
      handleSubmission,
    }
  },
}
</script>

<style>

</style>
